import PropTypes from "prop-types";

import ContentVeil from "@/components/ContentVeil";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import SecondaryActionsToolbar from "@/view/SecondaryActionsToolbar/SecondaryActionsToolbar";
import usePresentModeContext from "@/view/utils/usePresentModeContext";
import useViewportIsNotDesktop from "@/view/utils/useViewportIsNotDesktop";
import ContentDisplayDetails from "../ContentDisplayDetails";
import VideoBody from "../VideoBody";
import VideoMobilePresentModeQuiz from "../VideoMobilePresentModeQuiz";
import VideoTranscript from "../VideoTranscript";
import CollapsibleTranscript from "./CollapsibleTranscript";
import { detailsRootCss, rootCss } from "./VideoDisplay.style";

const propTypes = {
  user: PropTypes.object,
  content: PropTypes.object,
  contentMetadata: PropTypes.object,
  matchedAssignments: PropTypes.array,
  bannerMode: PropTypes.shape({
    isBannerModeActive: PropTypes.bool.isRequired,
  }),
};
const VideoDisplay = ({
  bannerMode,
  content,
  contentMetadata,
  matchedAssignments,
  user,
}) => {
  const { isVideoPresentModeActive, isVideoPresentModeWithoutQuiz } =
    usePresentModeContext();
  const activitiesPanelIsAtBottomOfPage = useViewportIsNotDesktop();

  const mobileVideoPresentModeIsActive =
    isVideoPresentModeActive && activitiesPanelIsAtBottomOfPage;
  const showMobilePresentModeQuiz =
    mobileVideoPresentModeIsActive && !isVideoPresentModeWithoutQuiz;

  const { isTeacher, isStudent, isLiteUser } = useGetUserProperties();
  const onlyLiteUsers = isLiteUser && !isStudent;
  const isVideoBlocked = onlyLiteUsers && !content.data.is_lite;

  const renderTranscript = () => {
    if (isVideoBlocked) {
      return <ContentVeil />;
    }
    if (isStudent) {
      return <VideoTranscript contentId={content?.id} />;
    }
    return <CollapsibleTranscript contentId={content.id} />;
  };
  return (
    <div css={rootCss}>
      <VideoBody
        content={content}
        isVideoPresentModeActive={isVideoPresentModeActive}
        user={user}
        showVeil={isVideoBlocked}
      />
      {isVideoPresentModeActive ? null : (
        <ContentDisplayDetails
          __cssFor={{ root: detailsRootCss }}
          bannerMode={bannerMode}
          content={content}
          contentMetadata={contentMetadata}
          isStudent={isStudent}
          isTeacher={isTeacher}
        />
      )}
      <SecondaryActionsToolbar
        bannerMode={bannerMode}
        content={content}
        matchedAssignments={matchedAssignments}
        user={user}
      />
      {showMobilePresentModeQuiz ? <VideoMobilePresentModeQuiz /> : null}
      {renderTranscript()}
    </div>
  );
};

VideoDisplay.propTypes = propTypes;

export default VideoDisplay;
